import { render, staticRenderFns } from "./Instruct.vue?vue&type=template&id=de5e8f1e&scoped=true"
import script from "./Instruct.vue?vue&type=script&lang=js"
export * from "./Instruct.vue?vue&type=script&lang=js"
import style0 from "./Instruct.vue?vue&type=style&index=0&id=de5e8f1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de5e8f1e",
  null
  
)

export default component.exports